import { Injectable } from '@angular/core';
import { ApiClientProvider } from '../../../common';
import { IWalletsApiClient } from './i-wallets-api.client';
import { WalletsApiClient } from './wallets.api.client';
import { WalletsInMemoryApiClient } from './wallets.api.inmemory.client';

@Injectable({
  providedIn: 'root'
})
export class WalletsApiClientProvider extends ApiClientProvider<IWalletsApiClient> {
  constructor(
    private client: WalletsApiClient,
    private inMemoryClient: WalletsInMemoryApiClient
  ) {
    super();
  }

  protected override getInMemoryClient(): IWalletsApiClient {
    return this.inMemoryClient;
  }
  protected override getApiClient(): IWalletsApiClient {
    return this.client;
  }
}
